const SAVE_COUNTERS = 'SAVE_COUNTERS';

export default {
  SAVE_COUNTERS,
};
